<template>
    <el-container>
        <el-main>
            <el-row class="row">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/modules/prepare/prepare' }">分货管理</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">新增</a></el-breadcrumb-item>
                </el-breadcrumb>
            </el-row>
            <el-row style="margin-bottom: 10px">
                <el-card style="height: 80px">
                    <el-form :inline="true" :model="dataForm">
                        <el-form-item label="制单人:" style="padding-right:20px">
                            {{ dataForm.clientName }}
                        </el-form-item>
                        <el-form-item label="配货方式:" style="padding-right:20px">
                            {{ dataForm.goodsType.name }}
                        </el-form-item>
                        <el-form-item label="收货门店" >
                            <el-select v-model="dataForm.storeOptions" @change="handleChange" filterable
                                       placeholder="请选择">
                                <el-option
                                    v-for="item in storeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="{value:item.value,label:item.label}">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-row>
            <!-- 商品管理 -->
            <goodsList ref="goodsList" type="add" :client="clientInfo" :orderInfo="dataForm.storeOptions"></goodsList>
            <el-row style="text-align: center;margin-top: 10px">
                <el-button type="primary" @click="cancel">返回</el-button>
                <el-button type="success" @click="doSaveBill">提交</el-button>
            </el-row>
            <!-- 新增商品弹窗 -->
        </el-main>
    </el-container>
</template>
<script>
import {getPrepareDetailSelect} from "@/modules/server-api/prepare/prepareDetailSelect";
import {
    getPrepareList,//接口
    Customer_Types_Opts//配货方式，
} from "@/modules/server-api/prepare/prepare";
import {getPrepareDetail} from "@/modules/server-api/prepare/prepareDetail";
import dialogGoodsList from '../dialogGoodsList';
import goodsList from "../goodsList";

export default {
    components: {
        goodsList,
        dialogGoodsList,
    },
    data() {
        return {
            dataForm: {
                storeOptions: null,
                clientId: '',
                clientName: '',
                goodsType: Customer_Types_Opts.distribution
            },
            userInfo: {},//用户登录时的信息
            clientInfo: {}, //客户信息
            storeOptions: [],//门店选项
            isGetStore: false,//是否获取到门店
        }
    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('key')||'{}')
        //    拿到用户信息
        console.log('getUserInfo', this.userInfo)
        this.getUserList();
    },
    created() {

    },
    methods: {
        handleChange(val){
            console.log( 'handleChange', val );
        },
        //获取门店信息
        getUserList() {
            getPrepareList.getUserList(this.userInfo.token).then(resp => {
                if (resp && resp.succ === 1) {
                    this.clientInfo = resp.result.authorClientInfoBo || {};
                    this.dataForm.clientName = this.clientInfo.name
                    let stores = resp.result.authorStoreInfoBoList;
                    this.storeOptions = stores.map(item => {
                        return {
                            label: item.name,
                            value: item.out_code
                        }
                    })
                    console.log(this.clientInfo)
                }
            })
        },
        async getGoodsTableData() {
            //根据入库单获取商品
            this.totalNum = 0;
            if (this.billId) {
                let rep = await getPrepareDetailSelect.getDetailSelectList({
                    id: this.billId,
                    suggest: this.goodsSuggest,
                });
                // console.log(rep);
                if (rep&& rep.succ === 1) {
                    let resList = rep.result.details;
                    this.goodsList = resList;
                    this.tempGoodsList = resList;
                } else {
                    this.$notifyError("获取商品失败：" + rep.error);
                }
            } else {
                this.$notifyError("获取入库单id失败");
            }
        },
        //执行提交
        async doSaveBill() {
            //    判断需要信息是否存在
            console.log( 'doSaveBill', this.dataForm )
            let message = '';
            if (this.dataForm.clientName == null) {
                message = '提交失败:无制单人信息';
            }
            if (this.dataForm.storeOptions === null) {
                message = '提交失败:无门店信息';
            }
            this.tableData = this.$refs.goodsList.getGoods();
            console.log('this.tableData',this.tableData)
            if (this.tableData.length === 0) {
                message = '提交失败:无商品信息';
            }

            if ( message.length > 0  ){
                this.$notify({
                    title: '警告',
                    message: message,
                    type: 'warning'
                });
                return;
            }
            let dataForm = this.dataForm;
            let tableData = this.tableData;
            console.log('save', dataForm, tableData)
            let data = {
                storeCode: this.dataForm.storeOptions.value,
                storeName: this.dataForm.storeOptions.label,
                waybillUser: this.dataForm.clientName,
                goodsList: tableData
            }
            let res = await getPrepareDetail.getPrepareDetailList(data)
            if (res.code === 200) {
                this.$notify({
                    title: '成功',
                    message: '提交成功',
                    type: 'success'
                });
                this.$router.push({path: '/modules/prepare/prepare'}).catch(() => {
                })
            } else {
                this.$notify.error({
                    title: '错误',
                    message: res.error
                });
            }
        },
        //点击取消返回页面
        cancel() {
            this.$confirm('是否确认取消, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push({path: '/modules/prepare/prepare'}).catch(() => {
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
    }
}
</script>
<style>
.row {
    margin-bottom: 10px;
}

.center {
    text-align: center;
}
</style>
